import React, { useState, useEffect } from 'react'
import { EventsWrapper } from '../components/events/styles'
// import { useRouter } from 'next/router'
import HeroImage from '../../public/events/gs_events_landing.jpg'
import Hero from '../components/Hero'
import Reviews from '../components/events/Reviews'
import BookEvent from '../components/events/BookEvent'
import HeaderContent from '../components/events/HeaderContent'
import WhyGlamsquad from '../components/WhyGlamsquad'
import MarketServiceSelector from '../components/MarketServiceSelector/MarketServiceSelector'
import ServiceCardList from '../components/ServiceCardList'
import FAQ from '../faq'
import { loadMarkets, fetchEventServicesForMarket } from '../services'
import { useMarketContext } from '../components/MarketContext'
import imageOne from '../../public/events/event-carousel-1.jpg'
import imageTwo from '../../public/events/event-carousel-2.jpeg'
import imageThree from '../../public/events/event-carousel-3.jpeg'
import imageFour from '../../public/events/event-carousel-4.jpeg'
import imageFive from '../../public/events/event-carousel-5.jpeg'
import imageSix from '../../public/events/event-carousel-6.jpeg'
import imageSeven from '../../public/events/event-carousel-7.jpeg'
import imageEight from '../../public/events/event-carousel-8.jpeg'
import imageNine from '../../public/events/event-carousel-9.jpeg'
import imageTen from '../../public/events/event-carousel-10.jpeg'
import imageEleven from '../../public/events/event-carousel-11.jpeg'
import imageTwelve from '../../public/events/event-carousel-12.jpeg'
import imageThirteen from '../../public/events/event-carousel-13.jpg'
import imageFourteen from '../../public/events/event-carousel-14.jpeg'
import imageFifteen from '../../public/events/event-carousel-15.jpeg'
import imageSixteen from '../../public/events/event-carousel-16.jpeg'
import imageSeventeen from '../../public/events/event-carousel-17.jpeg'
import ImageScroll from '../components/ImageScroll'
import { Header2 } from '../styles/Components'

const eventImages = [
  imageOne,
  imageTwo,
  imageThree,
  imageFour,
  imageFive,
  imageSix,
  imageSeven,
  imageEight,
  imageNine,
  imageTen,
  imageEleven,
  imageTwelve,
  imageThirteen,
  imageFourteen,
  imageFifteen,
  imageSixteen,
  imageSeventeen,
]

const FAQ_URL =
  'https://help.glamsquad.com/en-US/articles/eventsphotoshoots-47017'
const CANCELLATION_URL =
  'https://help.glamsquad.com/en-US/what-is-the-event-cancellation-policy-720238'

const FAQ_DATA_EVENTS = [
  {
    id: 1,
    title: 'What services do you provide for events?',
    body: `Glamsquad is experienced coordinating large groups, photoshoots, and corporate events. We can work with you to meet your event's needs. Please email events@glamsquad.com for more information!`,
  },
  {
    id: 2,
    title: 'What is the Event Cancellation Policy?',
    body: `Our cancellation policy is nonrefundable and ensures that our beauty professionals are compensated for their blocked-off time and commitment. This policy supports the hard work and dedication of our professionals, allowing us to maintain a high standard of service for all clients. Please review the detailed terms <a href='${CANCELLATION_URL}' target='_blank' rel='noopener noreferrer'>here</a> for specific timeframes and associated charges, including the non-refundable deposit required for booking.`,
  },
  {
    id: 3,
    title: 'Can I use a promo code when booking an event?',
    body: 'Promo codes are not valid for event or wedding services.',
  },
]

export const getStaticProps = async () => {
  try {
    const revalidationTime = process.env.NEXT_PUBLIC_REVALIDATE_MINUTES
    const [nyMarket] = await loadMarkets()
    const marketServices = await fetchEventServicesForMarket(nyMarket.id)

    return {
      props: {
        // matches the shape for main services page so component can be re-used
        marketServices: { Events: marketServices },
      },
      revalidate: revalidationTime * 60,
    }
  } catch (e) {
    console.log(e)
    return {
      props: {
        marketServices: [],
      },
    }
  }
}

const Events = ({ marketServices }) => {
  // const router = useRouter()
  const { markets, selectedMarket, setSelectedMarket } = useMarketContext()
  const [services, setServices] = useState(marketServices)

  useEffect(() => {
    if (selectedMarket) {
      fetchEventServicesForMarket(selectedMarket.id).then((s) => {
        setServices({ Events: s })
      })
    }
  }, [selectedMarket])

  const handleClick = () =>
    window.open(
      process.env.NEXT_PUBLIC_EVENTS_FORM,
      '_blank',
      'noopener, noreferrer',
    )


  // const handleClick = () => router.push('/events/contact')

  const reasons = [
    {
      title: 'Large-scale capabilities',
      content: `The same salon-quality services you know and love—at scale. There's no event too big or too small for our team to handle.`,
    },
    {
      title: 'Dedicated concierge support',
      content:
        'White glove service every step of the way. Your concierge will help customize your event and match you with the best pros for the job.',
    },
    {
      title: 'Flexible rate options',
      content: `We'll work closely with you to find the best pricing for your needs. (Yes, really.)`,
    },
  ]

  return (
    <EventsWrapper>
      <Hero
        className="hero-component"
        image={HeroImage}
        content={<HeaderContent {...{ handleClick }} />}
      />
      <WhyGlamsquad {...{ reasons }} />
      <MarketServiceSelector
        markets={markets}
        selectedMarket={selectedMarket}
        setSelectedMarket={setSelectedMarket}
        marketPrompt="Plan an event in: "
        hideTabs={true}
      />
      <ServiceCardList
        services={services}
        selectedMarket={selectedMarket}
        showServiceInfo={false}
        showOnlyBookButton={true}
      />
      <Reviews />
      <div className="dazzling-header">
        <Header2>Make it dazzling</Header2>
      </div>
      <ImageScroll images={eventImages} />
      <div className="faq-wrapper">
        <FAQ data={FAQ_DATA_EVENTS} url={FAQ_URL} />
      </div>
      <BookEvent {...{ handleClick }} />
    </EventsWrapper>
  )
}

export default Events
